import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import "../css/home.css";

const About = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <section
      id="about"
      className="w-full min-h-screen px-5 md:px-16 lg:px-24 scroll-mt-28"
    >
      <div className="mx-auto max-w-6xl">
        <p className="text-center font-mono text-lg uppercase tracking-[0.35em] text-zinc-500">
          About
        </p>
        <h2 className="mt-4 text-center font-mono text-3xl font-semibold text-white md:text-4xl">
          Building clean, responsive experiences for the web
        </h2>
        <p className="mx-auto mt-4 max-w-3xl text-center text-base leading-7 text-zinc-300 md:text-lg">
          I am a frontend developer with a strong focus on usability, responsive
          layouts, and maintainable React applications. I enjoy turning ideas
          into clear interfaces that feel smooth, practical, and easy to use.
        </p>

        <div className="mt-5 grid gap-8 lg:grid-cols-[1.1fr_0.9fr]">
          <div data-aos="fade-right" className="space-y-6">
            <div className="rounded-[2rem] border border-white/10 bg-gradient-to-br from-zinc-950 via-zinc-900 to-zinc-950 p-8 shadow-lg shadow-black/30">
              <div className="inline-flex rounded-full border border-white/10 bg-white/5 px-4 py-2 font-mono text-sm text-zinc-200 shadow-sm">
                Frontend Developer | React | JavaScript
              </div>

              <h3 className="mt-6 font-mono text-3xl font-semibold leading-tight text-white">
                About Me
              </h3>

              <div className="mt-6 space-y-4 text-zinc-300">
                <p className="leading-7">
                  Hello, I am Bindu. I am a Frontend Developer with a B.Tech in
                  Computer Science (2011), currently restarting my career after
                  a break.
                </p>
                <p className="leading-7">
                  I have hands-on experience building frontend interfaces
                  through freelance work and self-driven projects. My core stack
                  includes React, JavaScript, HTML, CSS, Tailwind, and Firebase.
                </p>
                <p className="leading-7">
                  I enjoy transforming ideas into clean, responsive experiences
                  that feel approachable and polished. My focus is not just on
                  making things work, but on making them easy to use and easy to
                  maintain.
                </p>
                <p className="leading-7">
                  After a career break, I have been steadily strengthening my
                  skills and building projects that reflect real problem
                  solving. I bring patience, ownership, and a genuine love for
                  learning.
                </p>
              </div>

              <div className="mt-8 flex flex-wrap items-center gap-4">
                <a
                  href="#contact"
                  className="inline-flex items-center justify-center min-w-[150px] px-6 py-3 
                            rounded-full  text-md font-bold text-indigo-600 border border-indigo-600
                            transition-all duration-500 ease-in-out
                            hover:-translate-y-1 hover:bg-indigo-600 hover:text-white hover:shadow-md"
                >
                  Let&apos;s Connect
                </a>
                <a
                  href="#projects"
                  className="inline-flex items-center justify-center min-w-[150px] px-6 py-3 
                            rounded-full  text-md font-bold  bg-indigo-600 text-white-600 border border-indigo-600
                            transition-all duration-200 ease-in-out
                            hover:-translate-y-1 hover:bg-transparent hover:text-white hover:shadow-md"
                >
                  See My Work
                </a>
              </div>
            </div>

            <div className="grid gap-4 sm:grid-cols-3">
              <div className="rounded-2xl border border-white/10 bg-zinc-950 p-5 text-center shadow-sm shadow-black/20">
                <p className="font-mono text-3xl font-bold text-white">2+</p>
                <p className="mt-2 text-xs uppercase tracking-[0.2em] text-zinc-500">
                  Years Learning
                </p>
              </div>
              <div className="rounded-2xl border border-white/10 bg-zinc-950 p-5 text-center shadow-sm shadow-black/20">
                <p className="font-mono text-3xl font-bold text-white">6+</p>
                <p className="mt-2 text-xs uppercase tracking-[0.2em] text-zinc-500">
                  Projects Built
                </p>
              </div>
              <div className="rounded-2xl border border-white/10 bg-zinc-950 p-5 text-center shadow-sm shadow-black/20">
                <p className="font-mono text-3xl font-bold text-white">100%</p>
                <p className="mt-2 text-xs uppercase tracking-[0.2em] text-zinc-500">
                  Responsive Focus
                </p>
              </div>
            </div>
          </div>

          <div data-aos="fade-left" className="space-y-5">
            <div className="rounded-[1.75rem] border border-white/10 bg-zinc-950 p-6 shadow-sm shadow-black/20">
              <p className="font-mono text-sm uppercase tracking-[0.25em] text-zinc-500">
                Strengths
              </p>
              <ul className="mt-5 space-y-4 text-zinc-300">
                <li className="flex items-start gap-3">
                  <span className="mt-1 h-2.5 w-2.5 rounded-full bg-zinc-200" />
                  Strong foundation in React, JavaScript, and modern frontend
                  workflows.
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-1 h-2.5 w-2.5 rounded-full bg-zinc-200" />
                  Experience building responsive, user-friendly interfaces for
                  real projects.
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-1 h-2.5 w-2.5 rounded-full bg-zinc-200" />
                  Reliable debugging and a clean, maintainable approach to code.
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-1 h-2.5 w-2.5 rounded-full bg-zinc-200" />
                  Quick learner who adapts well to new tools, teams, and product
                  needs.
                </li>
              </ul>
            </div>

            <div className="grid gap-4 sm:grid-cols-2">
              <div className="rounded-2xl border border-white/10 bg-zinc-900 p-5 shadow-sm shadow-black/20">
                <h3 className="font-mono text-lg font-semibold text-white">
                  What I bring
                </h3>
                <p className="mt-2 text-sm leading-6 text-zinc-300">
                  Reusable UI, responsive layouts, component thinking, and a
                  careful eye for detail.
                </p>
              </div>
              <div className="rounded-2xl border border-white/10 bg-zinc-900 p-5 shadow-sm shadow-black/20">
                <h3 className="font-mono text-lg font-semibold text-white">
                  What I value
                </h3>
                <p className="mt-2 text-sm leading-6 text-zinc-300">
                  Clarity, collaboration, consistency, and building products
                  that feel simple for users.
                </p>
              </div>
            </div>

            <div className="rounded-[1.75rem] border border-white/10 bg-zinc-900 p-6 text-white shadow-lg shadow-black/30">
              <p className="font-mono text-sm uppercase tracking-[0.25em] text-zinc-400">
                Current Focus
              </p>
              <p className="mt-4 text-lg leading-8 text-zinc-100">
                I am actively looking for opportunities where I can contribute
                to meaningful frontend work, continue growing with modern tools,
                and help build interfaces that people genuinely enjoy using.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
